<section
	class="loading-content show flex items-center justify-center fixed w-full h-full top-0 left-[0px] z-[4100]"
	[class.fixed]="position === 'fixed'"
	[class.absolute]="position === 'absolute'"
>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="57"
		height="57"
		viewBox="0 0 57 57"
		stroke="#007AFF"
	>
		<g fill="none" fill-rule="evenodd">
			<g transform="translate(1 1)" stroke-width="2">
				<circle cx="13.3084" cy="50" r="5">
					<animate
						attributeName="cy"
						begin="0s"
						dur="2.2s"
						values="50;5;50;50"
						calcMode="linear"
						repeatCount="indefinite"
					/>
					<animate
						attributeName="cx"
						begin="0s"
						dur="2.2s"
						values="5;27;49;5"
						calcMode="linear"
						repeatCount="indefinite"
					/>
				</circle>
				<circle cx="22.8458" cy="13.4972" r="5">
					<animate
						attributeName="cy"
						begin="0s"
						dur="2.2s"
						from="5"
						to="5"
						values="5;50;50;5"
						calcMode="linear"
						repeatCount="indefinite"
					/>
					<animate
						attributeName="cx"
						begin="0s"
						dur="2.2s"
						from="27"
						to="27"
						values="27;49;5;27"
						calcMode="linear"
						repeatCount="indefinite"
					/>
				</circle>
				<circle cx="44.8458" cy="41.5028" r="5">
					<animate
						attributeName="cy"
						begin="0s"
						dur="2.2s"
						values="50;50;5;50"
						calcMode="linear"
						repeatCount="indefinite"
					/>
					<animate
						attributeName="cx"
						from="49"
						to="49"
						begin="0s"
						dur="2.2s"
						values="49;5;27;49"
						calcMode="linear"
						repeatCount="indefinite"
					/>
				</circle>
			</g>
		</g>
	</svg>
</section>
